<div class="row">
    <div class="col-lg-12">
    <label class="col-form-label font-bold">Registros a Importar</label>
    </div>
</div>
<div class="row">
    <div class="table table-striped">
    <p-table #dt [value]="registros" [rows]="10" dataKey="id" [scrollable]="true" 
             scrollDirection="both" scrollHeight="300px">
        
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="legajo">Legajo <p-sortIcon field="legajo"></p-sortIcon></th>
                <th pSortableColumn="IDFiscal">Id Fiscal <p-sortIcon field="IDFiscal"></p-sortIcon></th>
                <th pSortableColumn="nombre">Nombre <p-sortIcon field="nombre"></p-sortIcon></th>
                <th pSortableColumn="apellido">Apellido <p-sortIcon field="apellido"></p-sortIcon></th>
                <th style="width: 300px" pSortableColumn="message">Errores <p-sortIcon field="message"></p-sortIcon></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-reg let-rowIndex="rowIndex">
            <tr>
                <td>{{reg.legajo}}</td>
                <td>{{reg.IDFiscal}}</td>
                <td>{{reg.nombre}}</td>             
                <td>{{reg.apellido}}</td>    
                <td style="width: 300px">
                    <ng-template ngFor let-error [ngForOf]="reg.errores">
                      <!-- Cada error en una fila separada -->
                      <div>{{error}}</div>
                    </ng-template>
                </td>
            </tr>
        </ng-template>
    </p-table>

    </div>
</div>
<br>
<div class="buttons">
    <button mat-button type="button" (click)="cancelar()" class="button">Cerrar</button>
    <button mat-button type="button" (click)="confirmar()" class="btn btn-primary" [disabled]="!confirmButtonEnabled">Confirmar</button>
</div>